export default __webpack_public_path__ + "static/media/BackButton.2435139c.png";